import React, { useState } from 'react';
import MannaLogo from '../../../assets/images/MannaProviderLogo.png';

interface ImageCellProps {
  logo: string;
  fillContainer?: boolean;
}

export const ImageCell: React.FC<ImageCellProps> = ({ logo, fillContainer = false }) => {
  const [imgSrc, setImgSrc] = useState(logo || MannaLogo);

  return (
    <div
      style={{
        border: '1px solid #D9DBE9',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 40,
        width: 40,
        borderRadius: 15,
        overflow: 'hidden',
        backgroundColor: fillContainer ? '#fff' : 'transparent'
      }}>
      <img 
        alt="product logo" 
        src={imgSrc} 
        style={{ 
          height: fillContainer ? '100%' : 25, 
          width: fillContainer ? '100%' : 25,
          objectFit: fillContainer ? 'cover' : 'contain'
        }}
        onError={() => {
          // Fallback to Manna logo if image fails to load
          setImgSrc(MannaLogo);
        }}
      />
    </div>
  );
};
